import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {formatText} from 'common/util/format-text';
import timing from 'common/stylesheets/mixins/timing.json';

import template from './index.jade';
import css from './index.styl?inline';

export class ContextPanelInternal extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'tooltip-data': `json`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        delayRemove: timing[`$mp-fast`],
        description: ``,
      },
      helpers: {
        formatText,

        shouldShow: () => {
          const tooltipData = this.attr(`tooltip-data`);
          if (!tooltipData) {
            return false;
          }

          // Don't show tooltip if no values are defined
          return Object.values(tooltipData).some((v) => (Array.isArray(v) ? !!v.length : !!v));
        },

        handleTextEditorSave: (ev, item) => {
          this.dispatchEvent(
            new CustomEvent(`changeDescription`, {
              detail: {description: ev.detail.value, item},
            }),
          );
          this.update({description: ev.detail.value});
        },

        handleMouseEnter: () => {
          this.dispatchEvent(new CustomEvent(`hoverIn`));
        },

        handleMouseLeave: () => {
          this.dispatchEvent(new CustomEvent(`hoverOut`));
        },

        editorInserted: (vnode) => {
          this.textEditor = vnode.elm;
        },

        actionClick: (ev, action) => {
          this.dispatchEvent(
            new CustomEvent(`actionClick`, {
              composed: true,
              cancelable: true,
              detail: {
                name: action.name,
                item: action.item,
              },
            }),
          );
        },

        getDisplayData: () => this.attr(`tooltip-data`) || {},
      },
    };
  }

  setDescription() {
    if (this.attr(`tooltip-data`)) {
      const {description} = this.attr(`tooltip-data`);
      this.update({description});
    }
  }

  connectedCallback() {
    super.connectedCallback(...arguments);
    this.setDescription();
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);
    if (attr === `tooltip-data`) {
      //TODO [shayan] find a better way
      if (this.textEditor) {
        this.textEditor.cancelEdit();
      }
      this.setDescription();
    }
  }
}

export const ContextPanelInternalEl = defineAndMakeJsxFactory(`mp-context-panel-internal`, ContextPanelInternal);
